<template>
  <div id="_maps">
    <info-block :title="$getModuleTitle(currentEvent.modules, 'AreaMaps')" :desc="$t('networking.description')" :button="null" :url="null">
      <template slot="input">
        <el-input
          v-model="searchTerm"
          :placeholder="$t('search')"
          :loading="$store.state.eventLoading == 'maps'"
          :suffix-icon="$store.state.eventLoading == 'maps' ? 'el-icon-loading' : 'el-icon-search'"
          @clear="
            searchTerm = null;
            $store.dispatch('getMaps', { searchTerm: null, id: currentEvent.id, route: false });
          "
          clearable
        ></el-input>
      </template>
    </info-block>
    <div class="maps-container">
      <Nodata :title="$getModuleTitle(currentEvent.modules, 'AreaMaps')" :description="saloonID == null && searchTerm == null && searchTerm != '' ? $t('contentNotFound') : $t('contentFilterNotFound')" anim="holacon-maps-lottie" :loading="loading == 'maps'" v-if="currentMaps.length == 0" :button="$t('refresh')" @btnClick="refresh" />

      <div class="maps-grid">
        <a :href="maps.image" data-lightbox="maps-image" :data-title="maps.title" v-for="(maps, index) in currentMaps" :key="index" class="maps-block">
          <div :style="'background-image: url(' + $imageus + maps.image + '?width=200&height=200&mode=cover);'" class="maps-image"></div>
          <div class="maps-header">
            <p class="fullname">
              {{ maps.title }}
            </p>
            <!-- <p class="title" v-if="maps.title != null ">
                {{ maps.title }}
              </p> 
              <p class="title" v-if="maps.firmName != null ">
                <b>@ {{ maps.firmName }}</b>
              </p> -->
          </div>
          <!-- <div class="bottom-line" :style="'background-color: ' + currentEvent.color"></div> -->
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import moment from "moment";
import InfoBlock from "../../modules/InfoBlock";

export default {
  name: "AreaMapsComponent",
  components: {
    InfoBlock
  },
  data() {
    return {
      open: false,
      searchTerm: null,
      saloonID: null,
      timeout: null,
      loading: false
    };
  },
  methods: {
    searchFilter() {
      if (this.timeout != null) clearTimeout(this.timeout);
      if (this.searchTerm != null) {
        this.timeout = setTimeout(() => {
          this.$store.dispatch("getMaps", { searchTerm: this.searchTerm, id: this.currentEvent.id, route: false });
        }, 1000);
      }
    },
    openImage(maps) {
      $.fancybox.open({
        items: [maps.image]
      });
    },
    async refresh() {
      this.loading = "maps";
      if (this.timeout != null) clearTimeout(this.timeout);
      this.timeout = setTimeout(async () => {
        this.searchTerm = null;
        this.saloonID = null;
        await this.$store.dispatch("getMaps", { id: this.currentEvent.id, searchTerm: this.searchTerm, route: false });
        this.loading = false;
      }, 500);
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.$store.dispatch("getMaps", { id: this.currentEvent.id, route: false });
    });
  },
  computed: {
    currentEvent() {
      return this.$store.getters.getEvent;
    },
    currentMaps() {
      return this.$store.getters.getMaps;
    }
  },
  watch: {
    searchTerm: function() {
      this.searchFilter();
    }
  }
};
</script>

<style lang="less">
#_maps {
  display: flex;
  flex-direction: column;
  width: 100%;

  .maps-container {
    display: block;
    width: inherit;
    margin: 0 auto;

    .maps-search {
      display: flex;
      flex-direction: row;
      align-items: center;
      width: 100%;
      position: relative;
      margin-bottom: 20px;
      gap: 1rem;
      .el-input {
        width: 100%;
      }
    }

    .maps-grid {
      display: grid;
      grid-template-columns: 1fr 1fr 1fr;
      grid-gap: 10px;
      margin: 0px;

      .maps-block {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        overflow: hidden;
        box-shadow: 0px 2px 10px rgba(38, 142, 166, 0.1);
        background: white;
        border-radius: 12px;
        overflow: hidden;
        cursor: pointer;

        &:hover {
          background-color: #fbfbfb;
          transition: all 0.3s ease 0s;
        }

        .maps-image {
          background-size: cover;
          background-position: center;
          background-repeat: no-repeat;
          width: 100%;
          height: 100%;
          aspect-ratio: 8/6;
        }

        iframe {
          width: 100%;
          height: 100%;
          aspect-ratio: 8/6;
        }

        .maps-header {
          text-align: center;
          width: 100%;
          padding: 8px;
          background: #268ea6;
          .fullname {
            margin: 0;
            font-size: 16px;
            font-weight: 500;
            color: white;
            &.clamp {
              display: -webkit-box;
              -webkit-line-clamp: 1;
              -webkit-box-orient: vertical;
              overflow: hidden;
            }
          }

          .title {
            font-size: 13px;
            font-weight: 400;
            color: #505763;
            margin: 4px 0px;
          }
        }

        .bottom-line {
          width: 28%;
          height: 6px;
          border-radius: 3px;
          margin-bottom: -10px;
          margin-top: 10px;
        }
      }
    }
  }
}

@media (max-width: 768px) {
  #_maps {
    padding: 0px;
    .maps-container {
      padding: 0px 12px;
      .maps-grid {
        grid-template-columns: 1fr !important;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/event/Maps.vue